var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-3"},[_c('organism-qr-access-create-new',{on:{"createSiteAccess":_vm.createSiteAccessToApi}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }